function whichColor(i) {
  switch (i) {
    //  dual
    case 1:
      return "#17a362"

    //identical
    case 2:
      return "#6fe88c"

    //chill
    case 3:
      return "#c3f78f"

    //  mirror
    case 4:
      return "#e2f7a6"

    //kindred
    case 5:
      return "#e7f590"

    //look-a-like
    case 6:
      return "#f5d878"

    //  semi-dual
    case 7:
      return "#ffb266"

    //  illusion
    case 8:
      return "#f0cb48"

    //super-ego
    case 9:
      return "#f0ae07"

    //benifactee
    case 10:
      return "#cf9400"
    //  benefactor
    case 11:
      return "#cf9400"

    //supervisor
    case 12:
      return "#cf7500"
    //supervisee
    case 13:
      return "#cf7500"

    //  quasi-identical
    case 14:
      return "#f7674a"

    //contrary
    case 15:
      return "#d91414"

      //conflict
    case 16:
      return "#a60396"

    default:
      return 'gray'
  }
}

export { whichColor }